module.exports = __webpack_public_path__ + "static/media/ic_forward_arrow.b3d775d9.svg";